export const descriptions = {
  default:
    'Passwort vergessen? Kein Problem! Gib einfach deine E-Mail-Adresse ein, und wir senden dir einen Link, mit dem du dein Passwort zurücksetzen kannst.',
  pending: 'Bitte habe einen Moment Geduld, während wir deine Anfrage bearbeiten.',
  error:
    'Es ist ein Fehler beim Zurücksetzen deines Passworts aufgetreten. Wir konnten dein Passwort leider nicht zurücksetzen. Bitte versuche es erneut. Sollte das Problem weiterhin bestehen, kontaktiere unseren Support.',
  success:
    'Wenn ein Konto zu der übermittelten Adresse existiert, erhältst du eine E-Mail mit Anweisungen, wie du dein Passwort zurücksetzen kannst. Solltest du keine E-Mail erhalten, sieh bitte auch in deinem Spam-Ordner nach.',
};

export const titles = {
  default: 'Passwort vergessen?',
  error: 'Fehler beim Zurücksetzten deines Passworts',
  success: 'Passwort wurde zurückgesetzt',
};
